/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iconik_Metadata_Views_ErrorInputs */

const en_iconik_metadata_views_error = /** @type {(inputs: Iconik_Metadata_Views_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
};

const fr_iconik_metadata_views_error = /** @type {(inputs: Iconik_Metadata_Views_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
};

const de_iconik_metadata_views_error = /** @type {(inputs: Iconik_Metadata_Views_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
};

const it_iconik_metadata_views_error = /** @type {(inputs: Iconik_Metadata_Views_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
};

const ru_iconik_metadata_views_error = /** @type {(inputs: Iconik_Metadata_Views_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
};

const es_iconik_metadata_views_error = /** @type {(inputs: Iconik_Metadata_Views_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
};

const zh_cn2_iconik_metadata_views_error = /** @type {(inputs: Iconik_Metadata_Views_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
};

const ja_iconik_metadata_views_error = /** @type {(inputs: Iconik_Metadata_Views_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
};

const hi_iconik_metadata_views_error = /** @type {(inputs: Iconik_Metadata_Views_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
};

const pt_pt2_iconik_metadata_views_error = /** @type {(inputs: Iconik_Metadata_Views_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Unable to load metadata views: {error}" |
*
* @param {Iconik_Metadata_Views_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_views_error = /** @type {((inputs: Iconik_Metadata_Views_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_Views_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_metadata_views_error(inputs)
	if (locale === "de") return de_iconik_metadata_views_error(inputs)
	if (locale === "it") return it_iconik_metadata_views_error(inputs)
	if (locale === "ru") return ru_iconik_metadata_views_error(inputs)
	if (locale === "es") return es_iconik_metadata_views_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_metadata_views_error(inputs)
	if (locale === "ja") return ja_iconik_metadata_views_error(inputs)
	if (locale === "hi") return hi_iconik_metadata_views_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_metadata_views_error(inputs)
	return en_iconik_metadata_views_error(inputs)
});